'use strict';

angular.module('app')
.controller('TermsAndConditionsController', 
	function ($scope, $rootScope, $location, AuthenticationService, $cookies) {
		$scope.currentStep = 0;
		$scope.enabled = false;
		$scope.changeStep = changeStep;
		$scope.enableButton = enableButton;
		$scope.today = new Date();
		var isAgreedTerm = $cookies.get('isAgreedTerm') == 'true' ? true : false;

  		const terms = [
            {
                'title': 'Acceptable Use Policy',
                'file': '/files/terms-and-conditions/BBA Mastro Acceptable Use Policy.pdf'
            },
            {
                'title': 'Application Assurance Terms',
                'file': '/files/terms-and-conditions/BBA Mastro Application Assurance Terms.pdf'
            },
            {
                'title': 'EULA',
                'file': '/files/terms-and-conditions/BBA Mastro EULA.pdf'
            },
            {
                'title': 'License Agreement',
                'file': '/files/terms-and-conditions/BBA Mastro Licence Agreement.pdf'
            }
  		];

  		$scope.currentTerm = terms[$scope.currentStep];

		function changeStep(step){
			if(step == 4){
				// Redirect to Dashboard
				// Update Agree and Terms Condition
				AuthenticationService.acceptTerms(function(response){
					window.location = '/';
					$cookies.put('isAgreedTerm', true);
				}, function(error){
					console.log(error);
				})
			}else{
				$scope.currentStep = step;
				$scope.currentTerm = terms[$scope.currentStep];
				$scope.enabled = false;
			}
		}

		function enableButton() {
	        $scope.enabled = true;
	    };
	});


// WEBPACK FOOTER //
// ./js/controllers/TermsAndConditionsController.js